import {SwipePayment} from "./swipePayment";
import {ManualPayment} from "./manualPayment";

export class PaymentFactory {
    async create(type, data, handleSubmit) {
        switch (type) {
            case 'SWIPE':
                return new SwipePayment(data);
            case 'SELECTED':
            case 'MANUAL':
                if(data?.adminUser?.paymentGateways?.type === 'NMI') {
                    const manualPay = new ManualPayment(data, handleSubmit);
                    await manualPay.init(); // throws on script load failure — caller handles
                    return manualPay;
                } else {
                    return new ManualPayment(data);
                }
        }
    }
}
